import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';
import { PUITranslatePipe } from '../pipes/p-ui-translate.pipe';

@Component({
    selector: 'platform-list-drawer',
    standalone: true,
    imports: [SidebarModule, PUITranslatePipe, TooltipModule, FormsModule, InputTextModule],
    template: `
        <p-sidebar
            [(visible)]="visible"
            [position]="position"
            styleClass="md:w-8 sm:w-12 lg:w-4"
            (visibleChange)="onVisibleChange()"
        >
            <ng-template pTemplate="header">
                <span class="font-semibold text-xl" style="padding-left: 0.75rem">
                    {{ header | pTranslate }}
                </span>
            </ng-template>
            <div class="flex flex-column flex-1">
                <div class="flex-1 flex flex-column overflow-auto">
                    <div class="flex-1 flex overflow-auto">
                        <div class="flex flex-column gap-2 flex-1 p-3 h-full">
                            <div class="w-full">
                                <span class="w-full p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        type="text"
                                        class="w-full"
                                        pInputText
                                        placeholder="{{ 'default-cm-searchUser' | pTranslate }}"
                                        [(ngModel)]="searchQuery"
                                        (input)="searchFilter()"
                                    />
                                </span>
                            </div>
                            <div class="flex flex-column gap-2 overflow-y-auto h-full">
                                @if (filteredUsers.length === 0) {
                                    <div
                                        class="flex w-full h-full align-items-center justify-content-center flex-column text-xl"
                                    >
                                        {{ 'default-cm-noUsersFound' | pTranslate: 'No users found' }}
                                    </div>
                                }
                                @for (user of filteredUsers; track user) {
                                    <div
                                        class="flex align-items-center h-3rem py-3 px-4 rounded-md transition-colors transition-duration-300 text-primary-600 surface-400 cursor-pointer"
                                        tabindex="0"
                                    >
                                        <div class="flex w-full gap-2 justify-content-between align-items-center">
                                            <div class="flex justify-content-between gap-2">
                                                <div tooltipPosition="bottom" [pTooltip]="user?.userName">
                                                    <span class="icon-value">{{ user?.userName }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-sidebar>
    `,
    styles: [],
})
export class ListDrawerComponent<Type extends User> {
    @Input() position: 'right' | 'left' | 'bottom' | 'top' = 'right';
    @Input() visible: boolean = false;
    @Input() filteredUsers: Type[] = [];
    @Input() header: string = '';

    @Output() filterUsers = new EventEmitter<any>();
    @Output() visibleChange = new EventEmitter<any>();

    searchQuery: string = '';

    searchFilter() {
        this.filterUsers.emit(this.searchQuery);
    }

    onVisibleChange() {
        this.visibleChange.emit(this.visible);
    }
}

interface User {
    userName: string;
}
